import React from "react";
import Statistics from "../mainCom/Statistics";
import StudentCard from "../mainCom/StudentCard";
import AttendChart from "./AttendChart";
import DonutChart from "./DonutChart";
import LineChart from "./LineChart";
import { MyResponsiveBar, MyResponsiveLine } from "../pages/chats/Novio";
import Transiton from "./Transiton";
import "./home.css";
import Notice from "./Notice";
import Charts from "./Charts";
import { Profile } from "./Profile";
const Home = () => {
  return (
    <div className=" bg-[#f8f8f8cc]">
      <div className="flex flex-col lg:flex-row  gap-x-8 gap-y-8 ">
        <div className=" bg-white rounded-md shadow-md flex-1">
          <Profile></Profile>
        </div>

        <div className="  flex flex-col md:flex-row lg:flex-[2] lg:flex-row gap-x-8 gap-y-8">
          <div className=" flex-1">
            <StudentCard></StudentCard>
          </div>
          <div className="flex-1  ">
            <Statistics></Statistics>
          </div>
        </div>
      </div>
      <div className=" flex flex-col md:flex-row   gap-x-8 gap-y-4 mt-8">
        <div className="flex-1 ">
          <div className="flex justify-between ">
            <div className=" p-2 w-[46%] h-44 bg-white rounded-md shadow-md  ">
              <AttendChart></AttendChart>
            </div>
            <div className="  p-2  w-[46%] h-44 bg-white rounded-md shadow-md  ">
              <>
                <LineChart></LineChart>
              </>
            </div>
          </div>
          <div className=" bg-white rounded-md shadow-md ">
            <div className="flex p-4 mt-6">
              <div>
                <h1 className=" font-medium text-[#5E5873]">Attendance</h1>
                <p className=" text-sm mt-4">Total</p>
                <p className=" font-medium">24 classes</p>

                <p className=" text-[#908c9e] mt-5 text-sm">
                  68.2% more than last month.
                </p>
              </div>
              <div className=" w-[40%] h-32  ">
                <DonutChart></DonutChart>
              </div>
            </div>
          </div>
        </div>

        <div className=" flex text-[#5E5873] h-[360px] justify-between w-full md:w-[50%] border xl:flex-[2]  bg-white rounded-md shadow-md">
          <div className="md:p-4  w-full">
            <div className=" md:w-96 lg:w-full  h-full overflow-hidden ">
              <h1 className="font-medium px-4 text-[#5E5873] ">
                Transaction History
              </h1>

              <MyResponsiveLine></MyResponsiveLine>

              {/* <Charts></Charts> */}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 gap-x-8 flex flex-col md:flex-row  overflow-scroll">
        <div
          className=" flex-[2] bg-white   rounded-md border
      "
        >
          {" "}
          <Transiton></Transiton>
        </div>

        <div className="flex-[1] mt-5 md:mt-0 overflow-hidden ">
          <Notice></Notice>
        </div>
      </div>
    </div>
  );
};

export default Home;
